import React from 'react';
import { SectionContainer } from '../../../SectionContainer';
import { RPCResponseTable } from '../RPCResponseTable/index';
import { SyntaxDisplay } from '../SyntaxDisplay';
import { Text } from '../../../PageElements/Text';
import { getName } from '../../../../../utils/treeVisitors/helpers';
import { NestedTable } from '../../NestedTable';
import get from 'lodash/get';
import { getParamWithRequiredField } from '../utils';

export const RPCOperationView = ({
  operation,
  serviceName,
  prefix,
  artifactId,
}) => {
  const paramsWithRequiredFields = operation.params.map((param) => {
    const paramWithRequiredField = getParamWithRequiredField({
      param,
      operationRequiredFields: operation.requiredFields,
    });
    return paramWithRequiredField;
  });

  return (
    <React.Fragment>
      <SectionContainer>
        <SyntaxDisplay
          operation={operation}
          artifactId={artifactId}
          serviceName={serviceName}
        />
      </SectionContainer>
      {paramsWithRequiredFields.length > 0 ? (
        <NestedTable
          tableDepth={0}
          params={paramsWithRequiredFields}
          title="Request"
          hasRest={get(operation, 'extra.hasRest', true)}
          isRequest={true}
        />
      ) : (
        <SectionContainer title="Request">
          <Text size="medium" weight="thin">
            An empty object
          </Text>
        </SectionContainer>
      )}
      {operation.ret && operation.ret.type !== 'void' && (
        <RPCResponseTable
          response={operation.ret}
          prefix={prefix}
          pageName={getName(operation)}
        />
      )}
    </React.Fragment>
  );
};
